import { requireUid } from './auth';
import { readOptionalValue, writeValue } from './rtdb';

/**
 * Les avertissements, cote membre.
 *
 * C'est le seul geste de moderation qui parle. Tout le reste se subit
 * sans un mot — un contenu disparait, un compte se ferme, une publication
 * est refusee — et l'interesse en est reduit a deviner ce qu'on lui
 * reproche. Celui-la s'affiche, et il attend d'etre lu.
 *
 * L'accuse de lecture n'est pas une formalite : c'est ce qui distingue
 * « on l'a prevenu » de « on a ecrit quelque part ». Le membre seul peut
 * l'ecrire, et rien d'autre de la branche ne lui est ouvert.
 */
export interface Avertissement {
  id: string;
  at: number;
  texte: string;
}

/** Ce qui attend d'etre lu. Vide pour l'immense majorite des membres. */
export async function lireMesAvertissements(): Promise<Avertissement[]> {
  const uid = requireUid();
  const brut = await readOptionalValue<
    Record<string, { at?: number; texte?: string; lu?: boolean }>
  >(`moderation/avertissements/${uid}`);

  return Object.entries(brut ?? {})
    .filter(([, a]) => a.lu !== true)
    .map(([id, a]) => ({ id, at: a.at ?? 0, texte: a.texte ?? '' }))
    .sort((a, b) => a.at - b.at);
}

export async function direQueCEstLu(id: string): Promise<void> {
  await writeValue(`moderation/avertissements/${requireUid()}/${id}/lu`, true);
}
